import React from 'react';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { Button } from '../../CommonComponents/OPL/Button/Button';
import { Icon } from '../../CommonComponents/OPL/Icon/Icon';

interface Props {
  canAddAccounts: boolean;
  onAddAccount(): void;
}

export const NetWorthSidebarEmpty = ({ canAddAccounts, onAddAccount }: Props) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      justifyContent="center"
      height="100%"
      css="gap: 16px"
      p="24"
    >
      <Icon className="far fa-landmark" fontSize="h1" color="neutral.400" css="margin: 0 auto" />

      <Box>
        <Text color="neutral.600" fontSize="h6" fontWeight={600} textAlign="center" mb="8">
          Personal Finances
        </Text>

        <Text color="neutral.500" textAlign="center">
          {canAddAccounts
            ? 'Add accounts to begin your new financial journey.'
            : 'No accounts have been added yet.'}
        </Text>
      </Box>

      {canAddAccounts && (
        <Button leftIcon="fas fa-plus" size="large" onClick={onAddAccount}>
          Add Account
        </Button>
      )}
    </Box>
  );
};
